/**
 * One host's telemetry sample from the bridge's SignalR `hostMetrics`
 * broadcast (HostMetrics Azure Function, RynTerminalAgent, the Control
 * Center). Shared by the web Roost hosts pages and the wallboard on web and
 * mobile (WI 34539).
 */
export interface HostMetric {
  hostId: string;
  hostname: string;
  online: boolean;
  lastHeartbeat: string;
  cpu: { percent: number; cores: number; model?: string | null };
  mem: { usedBytes: number; totalBytes: number; percent: number };
  disk: {
    usedBytes: number;
    totalBytes: number;
    percent: number;
    mount?: string;
  };
  gpu?: {
    name: string;
    utilPercent: number;
    memUsedMiB: number;
    memTotalMiB: number;
  } | null;
  network?: { rxBytesPerSec: number; txBytesPerSec: number } | null;
  os?: string | null;
  kernel?: string | null;
  arch?: string | null;
  rynCoreRoot?: string | null;
  /**
   * WI 34278: expected-vs-running daemons from the Control Center. Absent when
   * the publisher does not report daemons, which is "not reported", not "none
   * missing".
   */
  daemons?: HostDaemons | null;
}

export interface HostDaemons {
  expected: number;
  checkedAt: string | null;
  missing: { label: string; reason: string | null; lastExit: number | null }[];
}

export interface HistoryPoint {
  ts: string;
  cpu: number;
  mem: number;
  disk: number;
  gpu: number;
  netRx: number; // bytes/sec
  netTx: number; // bytes/sec
}
